import { Box, MenuItem, Typography } from '@material-ui/core';
import { Button, ConfirmDialog, SelectField } from '@roc/ui';
import { useState } from 'react';

export const COMPLETION_NOTE_OPTIONS = [
  { label: 'Value Updated', value: 'Value Updated' },
  { label: 'Value Not Updated', value: 'Value Not Updated' },
  { label: 'Additional Info Requested', value: 'Additional Info Requested' },
  { label: 'Withdrawn / Not Pursued', value: 'Withdrawn / Not Pursued' },
];

interface CompletionNoteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (completionNote: string) => void;
}

export const CompletionNoteDialog: React.FC<CompletionNoteDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const [completionNote, setCompletionNote] = useState('');
  const [error, setError] = useState('');

  const handleClose = () => {
    setCompletionNote('');
    setError('');
    onClose();
  };

  const handleConfirm = () => {
    if (!completionNote) {
      setError('Please select a completion note.');
      return;
    }
    onConfirm(completionNote);
    setCompletionNote('');
    setError('');
  };

  const body = (
    <Box>
      <Typography style={{ marginBottom: 16 }}>
        Please confirm you want to mark the task as completed.
      </Typography>
      <SelectField
        label="Completion Note"
        value={completionNote}
        onChange={val => {
          setCompletionNote(val);
          setError('');
        }}
        options={COMPLETION_NOTE_OPTIONS}
        variant="outlined"
        fullWidth
        testId="completionNote"
        error={!!error}
        helperText={error}
      />
    </Box>
  );

  return (
    <ConfirmDialog
      open={open}
      title="Confirmation"
      body={body}
      confirmButtonText="Confirm"
      cancelButtonText="Close"
      handleConfirm={handleConfirm}
      handleClose={handleClose}
      handleCancel={handleClose}
    />
  );
};

export default CompletionNoteDialog;
